<template>
  <el-select
    v-model="yearModel"
    :disabled="disabled"
    :filterable="filterable"
    :loading="loading"
    :placeholder="$t('ESTIMATE_VEHICLES.MODEL_YEAR')"
    @change="yearChanged"
    multiple
  >
    <el-option
      v-if="allowNone"
      :value="null"
      :label="$t('ESTIMATE_VEHICLES.MODEL_YEAR')"
    />
    <el-option
      v-for="year in years"
      :key="year.value"
      :value="year.value"
      :label="year.label"
    >
    </el-option>
  </el-select>
</template>

<script>
import _ from "lodash";
import { Option, Select } from "element-ui";

export default {
  name: "years-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    value: {
      type: [Array, String, null, Number],
      default: null,
      description: "Value",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
  },

  data() {
    let yearModel = this.value;

    if (yearModel) {
      if (!Array.isArray(this.value)) {
        yearModel = [yearModel];
      }
    } else {
      yearModel = [];
    }
    return {
      yearModel,
      years: [],
    };
  },

  setup() {},

  created() {
    this.getYears();
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getYears();
    }, 1000),

    async getYears() {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            with_ids: this.yearModel,
          },
        };

        await this.$store.dispatch("estimateVehicleYear/list", params);
        const yearsArr = await this.$store.getters["estimateVehicleYear/list"];
        this.years = [];
        let tempArr = [];
        yearsArr.forEach((year) => {
          if (!tempArr.includes(year.year)) {
            tempArr.push(year.year);
            this.years.push({
              value: year.year,
              label: year.year,
            });
          }
        });
        if (!tempArr.includes(this.yearModel)) {
          this.yearModel = "";
          this.yearChanged("");
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },

    yearChanged(year) {
      this.$emit("yearsChanged", year);
    },
  },

  watch: {
    value() {
      if (!this.value) {
        this.yearModel = [];
        return;
      }
      
      this.yearModel = Array.isArray(this.value) ? this.value : [this.value];
    },
  },
};
</script>
